import { getComparableValue, getFiniteNumberValue } from '../shared/valueUtils';

import type { IRevenueGrowthFilterValue } from './types';

const REVENUE_GROWTH_OPT_MAP: IRecord<string> = {
  '<': '<',
  '<=': '<=',
  '>': '>',
  '>=': '>=',
  '=': '=',
  lt: '<',
  lte: '<=',
  gt: '>',
  gte: '>=',
  eq: '=',
};

const normalizeRevenueGrowthOpt = (opt?: string): string => {
  return REVENUE_GROWTH_OPT_MAP[opt || ''] || '';
};

const normalizeRevenueGrowthValue = (value?: string | number): string | number => {
  const normalizedValue = getFiniteNumberValue(value);

  return normalizedValue === null ? '' : normalizedValue;
};

export const normalizeRevenueGrowthFilterValue = (value?: IRevenueGrowthFilterValue): IComparableValue => {
  const comparableValue = getComparableValue(value);
  const opt = normalizeRevenueGrowthOpt(comparableValue.opt);

  if (!opt) {
    return {
      opt: '',
      value: '',
    };
  }

  return {
    opt,
    value: normalizeRevenueGrowthValue(comparableValue.value),
  };
};

export const getValidRevenueGrowthFilterValue = (
  value?: IRevenueGrowthFilterValue,
): {
  opt: string;
  value: number;
} | null => {
  const normalizedValue = normalizeRevenueGrowthFilterValue(value);

  if (!normalizedValue.opt || typeof normalizedValue.value !== 'number') {
    return null;
  }

  return {
    opt: normalizedValue.opt,
    value: normalizedValue.value,
  };
};
